import { render, staticRenderFns } from "./TxtInfo.vue?vue&type=template&id=7599982a&scoped=true&"
import script from "./TxtInfo.vue?vue&type=script&lang=js&"
export * from "./TxtInfo.vue?vue&type=script&lang=js&"
import style0 from "./TxtInfo.vue?vue&type=style&index=0&id=7599982a&scoped=true&lang=scss&"
import style1 from "./TxtInfo.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7599982a",
  null
  
)

export default component.exports